<ng-content select="pw-nav-tab"></ng-content>
